import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { Vector2 } from 'three'
import { KVAnnotation, KVInspectionArea, RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

export function getNewInspectionAreaMessage() {
  return {
    type: 'newInspectionArea',
    requiredData: ['inspectionAreaId'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const inspectionArea = KVInspectionArea.fromJSON(json)

      // Set user metadata
      inspectionArea.userName = kv.user?.name ?? ''
      inspectionArea.userEmail = kv.user?.email ?? ''
      // createdAt set in constructor

      // Create new array to ensure React detects the state change
      const updatedInspectionAreas = [
        ...(kv.inspectionAreas ?? []),
        inspectionArea,
      ]
      kv.setInspectionAreas(updatedInspectionAreas)

      if (kv.mouseTrackerRef.current) {
        const kvElementRect = kv.videoParent.current?.getBoundingClientRect()
        kv.setPopupMenuStartPosition(
          new Vector2(
            kv.mouseTrackerRef.current.x + 30 - (kvElementRect?.left ?? 0),
            kv.mouseTrackerRef.current.y - 30 - (kvElementRect?.top ?? 0)
          )
        )
      }
      kv.setSelectedMarkup(inspectionArea)

      const data: Record<string, unknown> = {
        inspectionAreas: updatedInspectionAreas.map((ia) =>
          KVInspectionArea.toJSON(ia)
        ),
      }

      let annotations = kv.annotations ? [...kv.annotations] : undefined
      if (annotations && json.annotationToInspectionArea) {
        const annotationToInspectionArea: Record<
          string,
          Record<string, string>
        > = (json.annotationToInspectionArea || {}) as Record<
          string,
          Record<string, string>
        >

        annotations = annotations.map((annotation) => {
          if (
            annotationToInspectionArea[annotation.id] &&
            annotationToInspectionArea[annotation.id].inspectionArea
          ) {
            annotation.tags['inspectionArea'] = {
              derivedTag: true,
              value: annotationToInspectionArea[annotation.id].inspectionArea,
            }
          }

          return annotation
        })

        kv.setAnnotations(annotations)
        data['annotations'] = annotations.map((a) => KVAnnotation.toJSON(a))
      }

      // Track inspection area in rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data,
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
